import { t } from 'i18next';
import { Modal, Box, Typography, Button } from '@mui/material';
import { useUploadAvatarModal } from './hooks/useUploadAvatarModal';
import { ImageUploader } from 'components/ImageUploader';

interface IUploadAvatarModalProps {
  onClose: () => void;
  isOpen: boolean;
}

export const UploadAvatarModal = ({
  onClose,
  isOpen,
}: IUploadAvatarModalProps) => {
  const { handleLoadLogo, handleUnloadLogo, handleSave, loading, logo } =
    useUploadAvatarModal({
      onClose,
    });

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          p: 4,
          top: '50%',
          left: '50%',
          boxShadow: 24,
          borderRadius: 2,
          position: 'absolute',
          bgcolor: 'background.paper',
          transform: 'translate(-50%, -50%)',
          width: 500,
        }}
      >
        <Typography variant='h6' component='h2'>
          {t('profile.detailsCard.uploadAvatarTitle')}
        </Typography>
        <Typography sx={{ my: 2 }}>
          {t('profile.detailsCard.uploadAvatarDescription')}
        </Typography>

        <ImageUploader
          croppedImage={logo}
          setCroppedImage={handleLoadLogo}
          onDelete={handleUnloadLogo}
        />

        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={onClose} sx={{ mr: 1 }}>
            {t('general.cancel')}
          </Button>
          <Button
            onClick={handleSave}
            variant='contained'
            color='secondary'
            loadingPosition='center'
            loading={loading}
            disabled={loading || !logo}
            sx={{ color: 'white' }}
          >
            {t('general.save')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
